<template>
   <div ref="toolbox" id="toolbox" :style="style" :class="{fixed: fixed}">
      <div class="collapsible" :class="{active: expanded}"  @click="expanded = !expanded" role="button" title="Expand the Toolbar">
         
      </div>

      <div id="toolbox-header">Tools</div>

      <div id="tools-container" class="content" :class="{active: expanded}">

         <div :class="{disabled: !activateMP}" id="BARD_DATA_MP" class="toolBtn --media-picker" role="button">
            <img v-if="!mpOpen" src="../.././assets/img/toolbox/ft-media-picker-off.svg" title="Media Library Picker" @click.stop="$emit('openMP')">
            <img v-else src="../.././assets/img/toolbox/ft-media-picker-on.svg" title="Media Library Picker" @click.stop="$emit('closeMP')">
         </div>
         
         <!-- Crop Tools -->
         <div :class="{disabled: !activateCrop}" id="BARD_ASSETS_CROP" class="toolBtn --crop expand" role="button" title="Crop Tools">
         <img src="../.././assets/img/toolbox/ft-crop.svg">
         
            <!-- *** Crop Tools flyout menu starts here *** -->
            <div class="flyout crop-tools-container right" style="z-index:9999;">
               <div id="BARD_ASSETS" class="toolBtn" role="button" title="Scale Up" @click="$emit('scale', 'up')">
                  <img src="../.././assets/img/toolbox/ft-resize-plus.svg">
               </div>
               <div id="BARD_ASSETS" class="toolBtn" role="button" title="Scale Down" @click="$emit('scale', 'down')">
                  <img src="../.././assets/img/toolbox/ft-resize-minus.svg">
               </div>
               <div id="BARD_ASSETS" class="toolBtn" role="button" title="Rotate Left" @click="$emit('rotate', 'left')">
                  <img src="../.././assets/img/toolbox/ft-rotate-left.svg">
               </div>
               <div id="BARD_ASSETS" class="toolBtn" role="button" title="Rotate Right" @click="$emit('rotate', 'right')">
                  <img src="../.././assets/img/toolbox/ft-rotate-right.svg">
               </div>
               <div id="BARD_ASSETS" class="toolBtn" role="button" title="Flip Vertical" @click="$emit('flip', 'vertical')">
                  <img src="../.././assets/img/toolbox/ft-flip-ver.svg">
               </div>
               <div id="BARD_ASSETS" class="toolBtn" role="button" title="Flip Horizontal" @click="$emit('flip', 'horizontal')">
                  <img src="../.././assets/img/toolbox/ft-flip-hor.svg">
               </div>
            </div> <!-- END flyout crop-tools-container -->
         </div>

         <!-- Editor Notes -->
         <!-- <div id="BARD_NOTES" 
            class="toolBtn --editors-notes expand" role="button"
            title="Editor Notes">
            <img src="../.././assets/img/toolbox/ft-editors-note.svg">

               <div class="flyout editor-tools-container" style="z-index:9999;">
                  <div id="BARD_ASSETS" class="toolBtn" role="button" title="Toggle Notes"  @click="$emit('toggleNotes')">
                     <notes-permissions-icon :color="'#fff'"></notes-permissions-icon>
                  </div>
                  <div id="BARD_ASSETS" class="toolBtn" role="button" title="Add Note" @click="$emit('notes')">
                     <add-notes-icon :color="'#fff'"></add-notes-icon>
                  </div>
                  </div>
               </div>
            
               
         </div> END Editor Notes -->

         <!-- Design Layers -->
         <!-- <div id="BARD_DESIGN" class="disabled toolBtn --design-layer expand" role="button" title="Design Layer">
         <img src="../.././assets/img/toolbox/ft-design-layers.svg">
         </div> END Design Layers -->

         <!-- Text Tools -->
         <!-- <div :class="{disabled: true}" id="BARD_DATA_TEXT" class="toolBtn --text expand" role="button" title="Text Tools">
         <img src="../.././assets/img/toolbox/ft-text.svg"> -->

            <!-- *** Text Tools flyout menu starts here *** -->
            <!-- <div id="text-tools-container"  class="flyout text-tools-container" style="z-index:9999;"> -->
               <!-- <div class="font-controls font-control-row">
                  <div class="left-col">
                     <div id="BARD_DATA_TEXT" title="Font Family">
                        <select id="font_family" name="font-family" onchange="event.stopPropagation(); setFont(this)">
                           <option value="font 1" selected>Font 1</option>
                           <option value="font 2">Font 2</option>
                           <option value="font 3">Font 3</option>
                        </select>
                     </div>
                  </div>

                  <div class="right-col">
                     <div id="BARD_DATA_TEXT" title="Font Weight">
                        <select id="font_weight" name="font-weight" onchange="event.stopPropagation(); setSize(this)">
                           <option value="400" selected>400</option>
                           <option value="600">600</option>
                           <option value="800">800</option>
                        </select>
                     </div>
                  </div>
               </div>END font-controls -->

               <!-- <div class="text-decoration-controls font-control-row" style="z-index:9999;">
                  <div class="left-col">
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Bold"  @click="$emit('fontStyle', 'bold')">
                        <img src="../.././assets/img/toolbox/bttn-bold.svg">
                     </div>
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Italic" @click="$emit('fontStyle', 'italic')">
                        <img src="../.././assets/img/toolbox/bttn-italic.svg">
                     </div>
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="All Caps" @click="$emit('fontStyle', 'caps')">
                        <img src="../.././assets/img/toolbox/bttn-caps.svg">
                     </div>
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Small Caps" @click="$emit('fontStyle', 'smallCaps')">
                        <img src="../.././assets/img/toolbox/bttn-small-caps.svg">
                     </div>
                  </div>

                  <div class="right-col">
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Underline" @click="$emit('fontStyle', 'underline')">
                        <img src="../.././assets/img/toolbox/bttn-underline.svg">
                     </div>
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Strikethrough" @click="$emit('fontStyle', 'strikeThrough')">
                        <img src="../.././assets/img/toolbox/bttn-overline.svg">
                     </div>
                  </div> -->
               <!-- </div>END text-decoration-controls -->

               <!-- <div class="alignment-controls font-control-row" style="z-index:9999;">
                  <div class="left-col">
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Left Align" @click="$emit('textAlign', 'left')">
                        <img src="../.././assets/img/toolbox/bttn-left-align.svg">
                     </div>
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Center Text" @click="$emit('textAlign', 'center')">
                        <img src="../.././assets/img/toolbox/bttn-center-text.svg">
                     </div>
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Right Align" @click="$emit('textAlign', 'right')">
                        <img src="../.././assets/img/toolbox/bttn-right-align.svg">
                     </div>
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Justify Text">
                        <img src="../.././assets/img/toolbox/bttn-block-align.svg">
                     </div>
                  </div> -->
                  <!-- *** JOSH, I'm not sure how you want to handle the leading. I just put the icon here for placement *** -->
                  <!-- <div class="right-col">
                     <div id="BARD_ASSETS" class="toolBtn" role="button" title="Set the Leading">
                     <img src="../.././assets/img/toolbox/icon-leading.svg">
                     </div>
                  </div> -->
               <!-- </div>END alignment-controls -->

               <!-- <div class="opacity-scale-controls font-control-row"> -->
                  <!-- <div class='left-col'>
                     <div id="BARD_ASSETS" class="opacity-control" title="Opacity">
                     <label for="opacityRange">Opacity</label>
                     <input type="range" min="1" max="100" value="100" class="slider" id="opacityRange" onchange="event.stopPropagation(); setOpacity(this)">
                     </div>
                  </div> -->
                  <!-- *** Not sure how to build out Vertically Scale as percentage; 
                  using input type number as a placeholder. Maybe it could work? 
                  *** -->
                  <!-- <div class="right-col">
                     <div id="BARD_ASSETS" title="Vertically Scale">
                     <form action="">
                        <input type="number" min="10" max="100" placeholder="90" value="90"/>
                     </form>
                     </div>
                  </div> -->
               <!-- </div>END opacity-scale-controls -->

               <!-- <div class="font-color-controls font-control-row">
                  <div class="font-colors-input">
                  <label for="hex-number">Hex #</label>
                  <select id="hex-number" name="hex-number" onchange="event.stopPropagation(); setColors(this)">
                     <option value="400" selected>bf8fe1</option>
                     <option value="600">183e6d</option>
                     <option value="800">e76700</option>
                  </select>
                  </div>
                  <div class="font-color-blocks">
                  <form action="">
                     <input type="color" />
                  </form>
                  </div>
               </div> -->
            <!-- </div>
         </div> -->

         <div :class="{disabled: !activateMove, active: moveActivated}" id="BARD_DESIGN" class="toolBtn --shapes" role="button" @click.stop="$emit('toggleMove'); moveActivated=!moveActivated">
            <img src="../.././assets/img/toolbox/ft-shapes.svg" title="Shapes">
         </div>

         <!-- <div id="BARD_DESIGN" class="disabled toolBtn --elements" role="button">
         <img src="../.././assets/img/toolbox/ft-design-elements.svg" title="Design Elements">
         </div>

         <div id="BARD_DESIGN" class="disabled toolBtn --magnify" role="button">
         <img src="../.././assets/img/toolbox/ft-magnify.svg" title="Magnify">
         </div>

         <div id="BARD_DESIGN" class="disabled toolBtn --brightness" role="button">
         <img src="../.././assets/img/toolbox/ft-brightness.svg" title="Brightness">
         </div>

         <div id="BARD_DESIGN" class="disabled toolBtn --paint-brush" role="button">
         <img src="../.././assets/img/toolbox/ft-paint-brush.svg" title="Paintbrush">
         </div> -->

         <div :class="{disabled: !activateColorWheel}" id="BARD_DESIGN" class="toolBtn --color expand" role="button" @click.stop="$emit('toggleCP')">
            <img src="../.././assets/img/toolbox/ft-color.svg" title="Color">
            <div class="flyout color-tools-container right" style="z-index:9999;">
               <chrome-picker v-model="colorPickerInit" class="color-picker" @input="$emit('colorChange', colorPickerInit)"/>
            </div>
         </div>

         <div id="ALL" class="toolBtn --full-screen" role="button" :class="{active: fullScreenActive}">
            <img src="../.././assets/img/toolbox/ft-full-screen.svg" title="Smart Canvas Full Screen" @click.stop="$emit('fullScreen'), $forceUpdate(), resetPos();">
         </div>

         <div id="ALL" class="toolBtn --preview" role="button">
            <img src="../.././assets/img/toolbox/ft-preview.svg" title="Smart Canvas Preview" @click.stop="$emit('preview');">
         </div>
      </div>
   </div>
</template>

<script>

export default {
   data() {
      return {
         expanded: true,
         startTop: 75,
         startLeft: 400,
         notesActivated: false,
         colorPickerInit: this.bgColor
      }
   },

   props: {
      activateMP: false,
      activateCrop: false,
      activateFont: false,
      activateColorWheel: false,
      activateOverlay: false,
      activateMove: false,
      moveActivated: false,
      mpOpen: false,
      fixed: false,
      fullScreenActive: false,
      bgColor: {
         default: '#000',
         required: false
      }
   },

   computed: {
      style() {
         if (!this.fixed) {
            return "top: " + this.startTop + "px; left: " + this.startLeft + "px;";
         } else {
            return "top: " + this.startTop + "px;";
         }
         
      }
   },

   methods: {
      resetPos: function() {
         if ($('#create_container').is('.full')) {
            $('#toolbox').css("left", this.startLeft).css("top", this.startTop);}
      },

      recalculateAfterResize() {
         $('#toolbox').css("left", this.startLeft).css("top", this.startTop);
      }
   },

   mounted() {
      if (!this.fixed) {
         $(function() {
            "use strict";
            $('#toolbox').draggable({
               containment: "#ds_wrapper",
               handle: "#toolbox-header",
               stop: function() { //apply flyout -> left class if we are too far right
                  $('#toolbox .flyout').addClass('right');
                  $('#toolbox .flyout').removeClass('left');
                  let xPos = this.getBoundingClientRect().x;
                  if (xPos > 1578) {
                     $('#toolbox .flyout').removeClass('right');
                     $('#toolbox .flyout').addClass('left');
                  }
               }
            });
         });
      }

      window.onresize = () => {
         this.recalculateAfterResize();
      }
   }
}
</script>

<style lang="scss" scoped>
#toolbox {
   z-index: 100;
   position: absolute;
   top: 75px;
   // left: 877px;
   min-width: 71px;
   min-height: 3.2em;
   margin: 0 auto;
   padding: 0 5px .5em 5px;
   background-color: transparent;
   text-align: center;
   color: $tb-font;
   cursor: move;

   &.fixed {
      position: absolute;
      cursor: unset;
      right: 0px;
      left: unset;
   }

   svg {
      max-width: 100%;
      height: auto;
   }
}
.collapsible {
   height: 1.15em;
   background-color: $tb-collapsible-bg;
   background-image: url('../.././assets/img/toolbox/ft-arrows-left.svg');
   background-repeat: no-repeat;
   background-position: center center;
   background-size: 75% 75%;
   color: $tb-font;
   cursor: pointer;
}
.collapsible.active{
   background-image: url('../.././assets/img/toolbox/ft-arrows-right.svg');
}
.content {
   display: none;
}

.content.active {
   display: block;
}

#toolbox-header {
   width: 100%;
   padding: 1em 0 1em 0;
   font-size: 0.688em;
   text-transform: uppercase;
   background-color: $tb-bg;
}
#tools-container {
   width: 100%;
   padding-top: .5em;
   padding-bottom: .5em;
   padding-right: .25em;
   padding-left: .25em;
   background-color: $tb-bg;
}
#tools-container .toolBtn {
   width: 42px;
   height: 42px;
   margin: 0 auto;
   padding: .5em;
   border: 1px solid transparent;
   border-radius: 10%;
   background-color: rgba(39, 49, 66, 1);
   text-align: center;
   cursor: pointer;

   &.disabled {
      opacity: .2;
   }
}
#tools-container .toolBtn:focus,
#tools-container .toolBtn:hover,
#tools-container .toolBtn.active, 
#tools-container .toolBtn:active {

   &:not(.disabled) {
    background-color: rgba(0, 0, 0, 0.35);
   }
}
.toolBtn {

   img, 
   svg {
      margin: 0 auto;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
   }
}

.toolBtn {
   &.--text img {
      width: 18px;
      height: 20px;
   }
}

.flyout {
    position: absolute;
    display: none;
    visibility: hidden;
    left: -255px;
    top: 90px;
    min-height: 48px;
    background-color: rgba(39, 49, 66, 1);
    color: white;

    &.right {
      right: -255px;
      left: 58px;
    }
}

.editor-tools-container {
   &.flyout {
      left: -85px;
   }
}

.color-tools-container {
   padding: 15px;
   &.flyout {
      top: 185px;

      &.left {
         left: -236px;
      }

      &.right {
         right: -255px;
      }
   }

}

.expand {
   &:focus,
   &:hover,
   &:active {
      &:not(.disabled) {
         .flyout {
            display: block;
            visibility: visible;
         }
      }
   }
}

.flyout .toolBtn {
    display: inline-block;
}

/* .crop-tools-container is the flyout menu for Crop Tools */
.crop-tools-container,
.text-tools-container,
.editor-tools-container {
    padding: .5em;
    text-align: left;
}

/* .text-tools-container is the flyout menu for Text Tools */
.expand:focus {

   .flyout {

      top: 218px;

      > div {
         margin-bottom: .5em;
         width: 100%;

         .toolBtn {
            padding: 3px !important;

            img, svg {
               width: 100%;
               height: auto;
            }
         }
      }
   }
}

.editor-tools-container {
   top: 135px;
}

select {
   background: transparent;
   color: white;
   border: 1px solid #5a5a5a;
   padding: 5px 0;
   border-radius: 5px;

   option {
      background: #273142;
   }
}

#font_family {
   width: 97%;
}

#font_weight {
   margin-left: 5px;
}

.font-control-row {
   display: flex;

   .left-col {
      width: 65%;
   }
}
</style>
